"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrench = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Wrench = function Wrench(_a) {
  var id = _a.id;
  var clipPathId = id ? "Wrench__clip0__".concat(id) : 'Wrench__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    d: "M6.491 3.645a.39.39 0 01.349-.244l3.046-.133a.49.49 0 01.415.216l1.874 2.677a.49.49 0 01.061.464l-1.167 2.817a.39.39 0 01-.348.244l-3.046.133a.49.49 0 01-.415-.216L5.386 6.926a.49.49 0 01-.061-.464L6.49 3.645z",
    opacity: "0.72"
  }), react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.09 5.795c.103-.27.46-.303.626-.067l3.984 5.69c.071.102.19.162.315.16l4.957-.114a.375.375 0 00.34-.239l1.802-4.618a.375.375 0 00-.042-.352L10.088.566c-.165-.236-.012-.561.277-.565a8.99 8.99 0 017.508 3.838 9 9 0 01.477 9.57c-.204.364-.2.817.044 1.155l3.821 5.28a1.496 1.496 0 01-.347 2.099l-2.477 1.77a1.542 1.542 0 01-2.14-.345l-3.742-5.17c-.25-.345-.69-.488-1.105-.398A9.003 9.003 0 012.09 5.795z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Wrench = Wrench;